<div *ngIf="isLoading" class="floating-container">
    <mat-spinner class="floating-spinner"></mat-spinner>
</div>
<div *ngIf="!isLoading">
    <mat-toolbar class="bar-filler"></mat-toolbar>
    <div class="small-margin"> 
        <mat-form-field class="fill-parent-width">
            <mat-label>{{'Pages.AddCard.CardNumber' | translate}}</mat-label>
            <input matInput type="tel" inputmode="numeric" minlength="13" maxlength="19" placeholder="0000 0000 0000 0000" autocomplete="off" [(ngModel)]="cardnumber" name="cardnumber">
        </mat-form-field>
        <mat-form-field class="fill-parent-width">
            <mat-label>{{'Pages.AddCard.ExpDate' | translate}}</mat-label>
            <input matInput type="text" pattern="[0-9]{2}/[0-9]{2}" autocomplete="off" [(ngModel)]="expdate" placeholder="00/00" name="expdate">
        </mat-form-field>
        <mat-form-field class="fill-parent-width">
            <mat-label>{{'Pages.AddCard.CVV' | translate}}</mat-label>
            <input matInput type="tel" minlength="3" max="3" autocomplete="off" placeholder="000" [(ngModel)]="cvv" name="cvv">
        </mat-form-field>
    </div>
    <mat-toolbar class="bar-filler"></mat-toolbar>
    <mat-toolbar color="primary" class="top-bar">
        <button mat-icon-button (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <div>{{'Pages.AddCard.Title' | translate}}</div>
        <div class="filler"></div>
        <button mat-icon-button (click)="save()">
            <mat-icon>done</mat-icon>
        </button>
    </mat-toolbar>
</div>